@if (this.liveInfo && this.unitInfo && this.idolInfo) {
<div class="container-fluid row d-flex p-0 justify-content-center">
  <h3 class="h3 col-12 text-center">
    {{this.liveInfo.liveTitle}}
  </h3>
  @if (this.liveInfo.liveSubtitle) {
  <h4 class="h4 col-12 text-center">
    {{this.liveInfo.liveSubtitle}}
  </h4>
  }
  <div class="col-md-4 col-sm-12 d-flex justify-content-center row p-1">
    <div class="col-sm-2 d-md-none"></div>
    <div class="col-md-12 col-sm-8">
      <img
      [src]="this.liveInfo.liveLogo"
      class="img-fluid"
      [style]="'background-color: ' + this.liveInfo.liveLogoBg + ';'">
    </div>
    <div class="col-sm-2 d-md-none"></div>
  </div>
  <!--table class="table table-bordered">
    <thead></thead>
    <tbody>
      <tr>
        <th>地點</th>
        <td>{{this.liveInfo.liveBuilding}}</td>
      </tr>
      <tr>
        <th>票價</th>
        <td></td>
      </tr>
    </tbody>
  </table-->
  <div class="row col-md-8 col-sm-12 d-flex justify-content-center p-1">
    <div class="card-group row p-0">
      <div class="card p-0 col-6">
        <div class="card-header">
          Day1 {{this.liveInfo.liveDay1}}
        </div>
        <div class="card-body p-1">
          <ul class="list-group list-group-flush">
            @for(unit of this.unitInfo; track unit.unitId; let i = $index) {
            @if (i <= 7 && this.displayUnit(unit, 1)) {
            <li class="list-group-item border-0 p-1">
              <div
                [style]="'background-color: ' + unit.color1 + ';'"
                class="p-1">
                {{unit.unitName}}
              </div>
              <ul class="list-group list-group-flush ps-2">
              @for (idol of unit.idols; track idol.idolId) {
                @if (!this.markIdol(idol.idolId, 0)) {
                  @if (this.displayIdol(idol.idolId, 1)) {
                    <li
                      class="list-group-item border-0 p-1 text-dark">
                      <div>{{idol.cv}} ({{idol.idolName}}役)</div>
                    </li>
                  }
                  @else {
                    <li
                      class="list-group-item border-0 p-1">
                      <div>&nbsp;</div>
                    </li>
                  }
                }
              }
              </ul>
            </li>
            }}
          </ul>
        </div>
      </div>
      <div class="card p-0 col-6">
        <div class="card-header">
          Day2 {{this.liveInfo.liveDay2}}
        </div>
        <div class="card-body p-1">
          <ul class="list-group list-group-flush">
            @for(unit of this.unitInfo; track unit.unitId; let i = $index) {
            @if (i <= 7 && this.displayUnit(unit, 2)) {
            <li class="list-group-item border-0 p-1">
              <div
                [style]="'background-color: ' + unit.color1 + ';'"
                class="p-1">
                {{unit.unitName}}
              </div>
              <ul class="list-group list-group-flush ps-2">
              @for (idol of unit.idols; track idol.idolId) {
                @if (!this.markIdol(idol.idolId, 0)) {
                  @if (this.displayIdol(idol.idolId, 2)) {
                    <li
                      class="list-group-item border-0 p-1 text-dark">
                      <div>{{idol.cv}} ({{idol.idolName}}役)</div>
                    </li>
                  }
                  @else {
                    <li
                      class="list-group-item border-0 p-1">
                      <div>&nbsp;</div>
                    </li>
                  }
                }
              }
              </ul>
            </li>
            }}
          </ul>
        </div>
      </div>
    </div>
  </div>
  @if (this.liveInfo.day1SetList && this.liveInfo.day2SetList && this.liveInfo.day1SetList.length > 0 && this.liveInfo.day2SetList.length > 0) {
    <div class="col-12 justify-content-center">
    <h3 class="h4 text-center">歌單</h3>
    <div class="card">
      <div class="card-header">
        <ul class="nav nav-tabs card-header-tabs">
          <li class="nav-item">
            <a href="javascript: void(0);" (click)="this.dayTab = 0" [ngClass]="{'disabled': this.dayTab == 0, 'active': this.dayTab == 0 }" class="nav-link" style="font-family: Meiryo" i18n>Day1</a>
          </li>
          <li class="nav-item">
            <a href="javascript: void(0);" (click)="this.dayTab = 1" [ngClass]="{'disabled': this.dayTab == 1, 'active': this.dayTab == 1 }" class="nav-link" style="font-family: Meiryo" i18n>Day2</a>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div [ngClass]="{'d-none': this.dayTab != 0}">
          <table class="table">
            <thead>
              <tr>
                <th>Index</th>
                <th>楽曲</th>
                <th>出演</th>
              </tr>
            </thead>
            <tbody>
              @for(song of this.liveInfo.day1SetList; track song; let i = $index) {
              <tr>
                <td>{{i + 1}}</td>
                <td>{{song.songName}}</td>
                <td>{{displaySinger(song)}}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        <div [ngClass]="{'d-none': this.dayTab != 1}">
          <table class="table">
            <thead>
              <tr>
                <th>Index</th>
                <th>楽曲</th>
                <th>出演</th>
              </tr>
            </thead>
            <tbody>
              @for(song of this.liveInfo.day2SetList; track song; let i = $index) {
              <tr>
                <td>{{i + 1}}</td>
                <td>{{song.songName}}</td>
                <td>{{displaySinger(song)}}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  }
</div>
}